<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      resizable
      border
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
      }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>

      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="
            row.samplePropertiesStatus === 'Y'
              ? 'success'
              : row.samplePropertiesStatus === 'D'
              ? 'danger'
              : 'primary'
          "
        >
          {{ row.v_samplePropertiesStatus }}
        </el-tag>
      </template>

      <template v-slot:samplePropertiesType="{ row }">
        <el-tag
          size="mini"
          :type="
            row.samplePropertiesType === 'A'
              ? 'success'
              : row.samplePropertiesType === 'B'
              ? 'primary'
              : 'danger'
          "
        >
          {{ row.v_samplePropertiesType }}
        </el-tag>
      </template>
      <template v-slot:imageUrl="{ row }">
        <el-image
          :src="
            row.imageUrl ? $osscdn(row.imageUrl) : '/image/static/img/nopic.jpg'
          "
          :preview-src-list="[
            row.imageUrl
              ? $osscdn(row.imageUrl)
              : '/image/static/img/nopic.jpg',
          ]"
          style="width:100px; height:66px"
        >
          <div slot="error" class="image-slot">
            <img
              src="/image/static/img/nopic.jpg"
              style="width: 100px; height: 66px"
            />
          </div>
        </el-image>
      </template>

      <template v-slot:opt="{ row }">
        <el-tooltip
          class="item"
          effect="dark"
          :content="$l('INDEX.btn_tips_view') || '查看'"
          placement="top"
        >
          <i
            class="el-icon-view tool-btn"
            @click="
              $emit('openEditFormDialog', {
                type: 'detail',
                code: row.samplePropertiesImageCode,
              })
            "
          ></i>
        </el-tooltip>
        <el-tooltip
          class="item"
          effect="dark"
          :content="$l('INDEX.btn_tips_edit') || '编辑'"
          placement="top"
          v-if="allow('M')"
          v-show="row.samplePropertiesStatus === 'N'"
        >
          <i
            class="el-icon-edit tool-btn"
            @click="
              $emit('openEditFormDialog', {
                type: 'edit',
                code: row.samplePropertiesImageCode,
              })
            "
          ></i>
        </el-tooltip>
        <el-tooltip
          class="item"
          effect="dark"
          :content="$l('INDEX.btn_tips_audit') || '审核'"
          placement="top"
          v-show="row.samplePropertiesStatus === 'N'"
          v-if="allow('C')"
        >
          <i class="el-icon-check tool-btn" @click="audit(row)"></i>
        </el-tooltip>
        <el-tooltip
          class="item"
          effect="dark"
          :content="$l('INDEX.btn_tips_del') || '删除'"
          placement="top"
          v-if="allow('D')"
          v-show="row.samplePropertiesStatus === 'N'"
        >
          <i class="el-icon-delete tool-btn" @click="del(row)"></i>
        </el-tooltip>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns.js'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [TableAutoHeight, EditLoading],
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    tablePage: {
      default: null,
      type: Object,
    },
    loading: {
      default: false,
    },
    components: {},
  },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.$emit('reload'),
        },
      },
      tableColumns: tableColumns(this),
    }
  },
  methods: {
    del(row) {
      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.$api
          .masterSamplePropertiesDelApi({
            samplePropertiesImageCode: row.samplePropertiesImageCode,
          })
          .then((res) => {
            this.$message({
              showClose: true,
              message: this.$l('INDEX.tips_delete_ok') || res.msg,
              type: 'success',
            })
            this.$emit('reload')
          })
      })
    },
    audit(row) {
      this.$confirm(
        this.$l('INDEX.tips_question_submitAudit') || '是否提交审核？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.loadingOpen()
        this.$api
          .masterSamplePropertiesAuditApi({
            samplePropertiesImageCode: row.samplePropertiesImageCode,
          })
          .then((res) => {
            this.loadingClose()
            this.$message({
              showClose: true,
              message: res.msg,
              type: 'success',
            })
            this.$emit('reload')
          })
          .catch(() => {
            this.loadingClose()
          })
      })
    },
  },
}
</script>
